<template>
  <div>
    <div class="themeBg"></div>
  </div>
</template>

<script>
export default {
    name: 'Back',
}
</script>

<style scoped>
.themeBg {
  content: "";
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  --color-filter: hue-rotate(25.4219deg);
  /* background-size: cover; */
  background-image: url("../img/gptBack4new.jpg"); /* 添加背景图片 */
  background-size: cover; /* 背景图片覆盖整个元素 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center center; /* 背景图片居中显示 */
  /* background-image: linear-gradient(transparent, rgb(250, 250, 250) 85%),
    url("../img/homeback.png"); */

  z-index: -2;

  opacity: 0.7;
}
</style>